var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0938 14.4375C14.6633 14.4375 15.125 13.9758 15.125 13.4062C15.125 12.8367 14.6633 12.375 14.0938 12.375C13.5242 12.375 13.0625 12.8367 13.0625 13.4062C13.0625 13.9758 13.5242 14.4375 14.0938 14.4375Z",
    fill: "#122D42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90625 14.4375C8.47579 14.4375 8.9375 13.9758 8.9375 13.4062C8.9375 12.8367 8.47579 12.375 7.90625 12.375C7.33671 12.375 6.875 12.8367 6.875 13.4062C6.875 13.9758 7.33671 14.4375 7.90625 14.4375Z",
    fill: "#122D42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0625 16.5V14.5345C2.0625 9.59492 6.02883 5.51715 10.9684 5.50006C12.1447 5.4959 13.3103 5.724 14.3983 6.17128C15.4863 6.61857 16.4753 7.27623 17.3086 8.10657C18.1419 8.9369 18.803 9.92356 19.2541 11.01C19.7053 12.0964 19.9375 13.2611 19.9375 14.4375V16.5C19.9375 16.6823 19.8651 16.8572 19.7361 16.9861C19.6072 17.1151 19.4323 17.1875 19.25 17.1875H2.75C2.56766 17.1875 2.3928 17.1151 2.26386 16.9861C2.13493 16.8572 2.0625 16.6823 2.0625 16.5Z",
    stroke: "#122D42",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 4.8125L5.42031 7.48281",
    stroke: "#122D42",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 4.8125L16.5948 7.46768",
    stroke: "#122D42",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/Android.bf67df5542cc6571393a289c5e3c8a01.svg";
export { ForwardRef as ReactComponent };